const dev = {
  API_ENDPOINT_URL: 'https://jsonplaceholder.typicode.com',
	...process.env
};

const prod = {
  API_ENDPOINT_URL: 'https://api.prod.com',
	...process.env
};

const test = {
  API_ENDPOINT_URL: 'https://api.test.com',
	...process.env
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
